'use strict';

var $ = require('jquery');
require('./lib/gmap');
require('gsap');
require('gsap/ScrollToPlugin');

var lightbox = require('lightbox2');
lightbox.option({
  'albumLabel': 'photo %1 of %2',
  'disableScrolling': true,
  'fadeDuration': 200,
  'resizeDuration': 500,
  'imageFadeDuration': 0,
  'wrapAround': true
});

var Swiper = require('swiper');
require('waypoints/lib/noframework.waypoints');
require('waypoints/lib/shortcuts/inview');

$(document).ready(function() {
  require('./lib/animation');
  var swiper = new Swiper('#slider', {
    pagination: '',
    grabCursor: false,
    autoplay: 3000,
    speed: 800,
    loop: true,
    centeredSlides: true,
    slidesPerView: 3,
    spaceBetween: 26
  });

  $('#prevSlide').on('click', function() {
    swiper.slidePrev();
  });

  $('#nextSlide').on('click', function() {
    swiper.slideNext();
  });

  swiper.stopAutoplay();

  var waypointPhotoSection = new Waypoint.Inview({
    element: document.getElementById('photo'),
    enter: function() {
      swiper.startAutoplay();
    },
    exit: function() {
      swiper.stopAutoplay();
    }
  });

  waypointPhotoSection;
});

$(window).on('load', function() {
  var mainImageSlider = new Swiper('#mainImageSlider', {
    pagination: '',
    grabCursor: false,
    autoplay: 5000,
    speed: 5000,
    loop: true,
    slidesPerView: 1,
    effect: 'fade',
    fade: {
      crossFade: true
    }
  });

  var waypointMainImage = new Waypoint.Inview({
    element: document.getElementById('mainImage'),
    enter: function() {
      mainImageSlider.startAutoplay();
    },
    exited: function() {
      mainImageSlider.stopAutoplay();
    }
  });

  waypointMainImage;
});

var navLink = $('#nav, #footerNav');
$(window).on('load resize', function() {
  if (window.matchMedia('(max-width: 768px)').matches) {
    navLink.on('click', 'a', function() {
      var $this = $(this),
        href = $this.attr('href'),
        topY = $(href).offset().top - 36;

      TweenMax.to($(window), 1, {
        scrollTo: {
          y: topY,
          autoKill: true
        },
        ease: Power2.easeInOut
      });

      return false;
    });
  } else {
    navLink.on('click', 'a', function() {
      var $this = $(this),
        href = $this.attr('href'),
        topY = $(href).offset().top - 80;

      TweenMax.to($(window), 1, {
        scrollTo: {
          y: topY,
          autoKill: true
        },
        ease: Power2.easeInOut
      });

      return false;
    });
  }
});
